import { render, staticRenderFns } from "./DomainClassPictureView.vue?vue&type=template&id=06ae9f72&scoped=true"
import script from "./DomainClassPictureView.vue?vue&type=script&lang=js"
export * from "./DomainClassPictureView.vue?vue&type=script&lang=js"
import style0 from "./DomainClassPictureView.vue?vue&type=style&index=0&id=06ae9f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae9f72",
  null
  
)

export default component.exports